import {createStore} from 'trim-redux'
const state = {
    navCollapsed : false,
    isAuth : false,
    user : null,
    navOpen:'',
    primary_color:'#232f3e',
    secondary_color:'#e4a438',
    x_price:'',
    logo:'',
    app_name:'',
    global_need_verification:0,
    primary_shop:null,
    admins:{},
    menu:[],
    features:{},
    about:{},
    setting:null,
    global_loading:false,

};
export const store = createStore(state);